import { MutationTree, GetterTree, ActionTree } from 'vuex'
import { SET_SHOW_RATING, SUBMIT_RATING } from '../types'
import { postFeedback } from '@/utils/rating'
import { RootState } from '..'

export interface RatingState {
    isShowRating: boolean;
    checkoutId: string;
}

interface SubmitRatingPayload {
    rating: number;
    notes: string;
}

const state: RatingState = {
    isShowRating: false,
    checkoutId: ''
}

const getters: GetterTree<RatingState, RootState> = {
    getShowRating: (state) => state.isShowRating,
    getCheckoutId: (state) => state.checkoutId
}

const mutations: MutationTree<RatingState> = {
    async [SET_SHOW_RATING](state, poolId) {
        if (state.isShowRating) state.isShowRating = false
        await new Promise((resolve) => setTimeout(resolve, 5000))
        state.isShowRating = true
        state.checkoutId = poolId
    },

    async [SUBMIT_RATING](state) {
        state.isShowRating = false
        state.checkoutId = ''
    }
}

const actions: ActionTree<RatingState, RootState> = {
    async submitRating({ commit, getters }, payload: SubmitRatingPayload): Promise<void> {
      await postFeedback(getters.getCheckoutId, payload.rating, payload.notes)
  
      commit(SUBMIT_RATING)
      return
    }
  }

export default {
    state,
    getters,
    actions,
    mutations,
}
